import { useState } from "react";

export default function MigrateButton({ dataReceviedHandler }) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [actionType, setActionType] = useState("");
  const [loading, setLoading] = useState(false);

  const openConfirm = (type) => {
    setActionType(type);
    setConfirmOpen(true);
  };

  const handleYes = () => {
    setLoading(true);

    dataReceviedHandler(actionType);

    setTimeout(() => {
      setLoading(false);
      setConfirmOpen(false);
    }, 800);
  };

  return (
    <>
      <li
        className="list-group-item"
        style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}
      >
        {/* Button 1 */}
        <button
          onClick={() => openConfirm("mj")}
          disabled={loading}
          style={btnStyle1}
        >
          Migrate Mj Ludo
        </button>

        {/* Button 2 */}
        <button
          onClick={() => openConfirm("cejora")}
          disabled={loading}
          style={btnStyle2}
        >
          Migrate Cejora
        </button>
      </li>

      {/* MODAL */}
      {confirmOpen && (
        <div style={overlayStyle}>
          <div style={modalStyle}>
            <h2 style={{ marginBottom: "10px" }}>Are you sure?</h2>
            <p style={{ color: "#555", marginBottom: "25px" }}>
              This action will be executed for: <b>{actionType}</b>
            </p>

            <div style={{ display: "flex", gap: "20px" }}>
              <button onClick={handleYes} style={yesBtn}>
                YES
              </button>

              <button onClick={() => setConfirmOpen(false)} style={noBtn}>
                NO
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const btnStyle1 = {
  background: "linear-gradient(135deg, #0f9b0f, #38ef7d)",
  color: "#fff",
  border: "none",
  padding: "10px 16px",
  borderRadius: "12px",
  cursor: "pointer",
  fontWeight: "600",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
};

const btnStyle2 = {
  background: "linear-gradient(135deg, #ff416c, #ff4b2b)",
  color: "#fff",
  border: "none",
  padding: "10px 16px",
  borderRadius: "12px",
  cursor: "pointer",
  fontWeight: "600",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const modalStyle = {
  background: "#fff",
  padding: "30px",
  borderRadius: "16px",
  width: "320px",
  textAlign: "center",
  boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
};

const yesBtn = {
  flex: 1,
  padding: "15px",
  fontSize: "18px",
  fontWeight: "bold",
  border: "none",
  borderRadius: "12px",
  background: "linear-gradient(135deg, #00b09b, #96c93d)",
  color: "#fff",
  cursor: "pointer",
};

const noBtn = {
  flex: 1,
  padding: "15px",
  fontSize: "18px",
  fontWeight: "bold",
  border: "none",
  borderRadius: "12px",
  background: "linear-gradient(135deg, #e52d27, #b31217)",
  color: "#fff",
  cursor: "pointer",
};
